<template>
    <div class="indexContent">
        <el-carousel height="26.5vw">
            <el-carousel-item v-for="item in 4" :key="item">
                <el-image :src="require('@/assets/image/banner.jpg')" fit="cover" class="banner" @click="bannerTap"></el-image>
            </el-carousel-item>
        </el-carousel>
        <!-- 右侧悬浮 -->
        <div class="contactList">
            <div class="contactpos">
                <el-image :src="require('@/assets/icon/contact01.png')" fit="cover" class="contactIcon"></el-image>
                <div class="contactName">联系客服</div>
                <div class="contactContent contactShow">
                    <div class="contactHi">Hi,联系专属客服</div>
                    <div class="contactTitle">为您寻找最适合的产品解决方案</div>
                    <div class="contactBox column">
                        <el-image :src="indexData.kefu" class="contactImg"></el-image>
                        <div class="contactTips">扫码添加客服微信</div>
                    </div>
                </div>
            </div>
            <div class="contactpos">
                <el-image :src="require('@/assets/icon/contact02.png')" fit="cover" class="contactIcon"></el-image>
                <div class="contactName">电话咨询</div>
                <div class="telBox contactShow">
                    <div style="display: flex;">
                        <el-image :src="require('@/assets/icon/contact03.png')" fit="cover" class="telIcon"></el-image>
                        <div>
                            <div class="telNum">{{ indexData.tel }}</div>
                            <div class="flex">
                                <div class="telName">{{ indexData.lianxiren }}</div>
                                <div class="workTime">（{{ indexData.gongzuotime }}）</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                userId: 0,
                indexData: {}
            }
        },
        mounted(){
            this.userId = localStorage.getItem("userId")
            // this.getIndexData()
            document.title = '全域赚钱联盟'
        },
        methods: {
            // 获取首页数据
            getIndexData(){
                this.request.get("index/index/center",{
                    params:{
                       
                    }
                })
                .then(res=>{
                    this.indexData = res.data
                    document.title = res.data.title
                    this.setTimer();
                })
            },
            // banner点击
            bannerTap(){
                if(!this.userId){
                    this.$router.push({ path:'/login/login', query:{router: 'union'} })
                    return
                }
                this.$router.push({ path:'/union/union' })
            }
            
        }
    }
</script>
<style lang="less" scoped>
    .indexContent{
        .banner{
            width: 100vw;
            height: 26.5vw;
            cursor: pointer;
        }
       .contactList{
            width: 72px;
            position: fixed;
            right: 20px;
            top: 40vh;
            z-index: 999;
            .contactpos{
                width: 72px;
                height: 72px;
                border-radius: 8px;
                background: #fff;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin-bottom: 8px;
                cursor: pointer;
                position: relative;
                &:hover{
                    box-shadow: 0px 4px 44px 0px rgba(0,0,0,0.04);
                    .contactShow{
                        display: block;
                    }
                }
                .contactIcon{
                    width: 24px;
                    height: 24px;
                }
                .contactName{
                    font: 12px/16px "Microsoft YaHei";
                    color: #73727A;
                    margin-top: 6px;
                }
                .contactContent{
                    width: 230px;
                    border-radius: 8px;
                    background: #0F59FE;
                    position: absolute;
                    left: -236px;
                    bottom: 0;
                    box-shadow: 0px 4px 44px 0px rgba(0,0,0,0.04);
                    display: none;
                    .contactHi{
                        padding: 18px 0 0 18px;
                        font: bold 14px/18px "Microsoft YaHei";
                        color: #fff;
                    }
                    .contactTitle{
                        padding: 6px 0 0 18px;
                        font: 12px/14px "Microsoft YaHei";
                        color: #fff;
                    }
                    .contactBox{
                        width: 230px;
                        height: 202px;
                        // border-radius: 8px 8px 0 0;
                        background: #fff;
                        margin-top: 12px;
                        .contactImg{
                            width: 138px;
                            height: 138px;
                            border-radius: 12px;
                            margin-top: 21px;
                        }
                        .contactTips{
                            font: 12px/14px "Microsoft YaHei";
                            color: #73727A;
                            margin-top: 6px;
                        }
                    }
                }
                .telBox{
                    padding: 13px 24px;
                    background: #fff;
                    border-radius: 8px;
                    position: absolute;
                    right: 78px;
                    bottom: 0;
                    box-shadow: 0px 4px 44px 0px rgba(0,0,0,0.04);
                    display: none;
                    .telIcon{
                        width: 32px;
                        height: 32px;
                        margin-right: 8px;
                    }
                    .telNum{
                        font: 20px/32px "Microsoft YaHei";
                        color: #161825;
                    }
                    .telName{
                        font: 14px/18px "Microsoft YaHei";
                        color: #161825;
                        margin-top: 4px;
                    }
                    .workTime{
                        font: 12px/16px "Microsoft YaHei";
                        color: #73727A;
                        margin-top: 6px;
                    }
                }
            }
       }
    }
</style>